import type { LoaderFunctionArgs, MetaFunction } from "react-router";
import { SITE_NAME } from "@/lib/constants";
import WalletPage from "@/pages/WalletPage";

export async function loader({ params }: LoaderFunctionArgs) {
  const address = params.address!;
  return { address };
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const address = data?.address ?? "";
  const shortAddr = address.length >= 10 ? `${address.slice(0, 6)}...${address.slice(-4)}` : address;
  const origin = "https://loadlogo.com";

  const title = `Wallet ${shortAddr} Avatar | ${SITE_NAME}`;
  const description = `Wallet avatar for ${shortAddr}. ENS reverse lookup with monogram fallback. Fetch wallet avatars via ${SITE_NAME}.`;

  return [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:image", content: `${origin}/og/wallet/${address}` },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:url", content: `${origin}/wallet/${address}` },
    { property: "og:site_name", content: SITE_NAME },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: `${origin}/og/wallet/${address}` },
    { tagName: "link", rel: "canonical", href: `${origin}/wallet/${address}` },
  ];
};

export default function WalletRoute() {
  return <WalletPage />;
}
